export class PlaceDetail {
    placeId?: string;
    externalId?: string;
    name?: string;
    placeType?: string;
    formattedAddress?: string;
    phoneNumber?: string;
    rating?: number;
    ratingCount?: number;
    icon?: string;
    websiteUrl?: string;
    mapUrl?: string;
    latitude?: number;
    longitude?: number;
    city?: string;
    district?: string;
    state?: string;
    countryCode?: string;
    countryName?: string;
    utcOffsetMinutes?: number;
    isPreferred?: boolean;
    isBlacklisted?: boolean;
    isStarRatingPolicyViolated?: any;
    starRatingViolationDescription?: any;
}
